import React from "react";

const FeesProgress = () => {
  const feeDetails = {
    pendingFees: 14877,
    feesPaid: 70123,
    totalFees: 85000,
  };

  return (
    <div className="container-fluid w-100 min-vh-25 position-relative p-6 rounded-3">
      <div
        className="position-absolute top-0 start-0 w-100 h-100 rounded-4"
        style={{
          backgroundImage: `url("https://png.pngtree.com/thumb_back/fh260/background/20250120/pngtree-horizontal-wooden-planks-with-prominent-grain-patterns-and-knots-image_16935145.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.3)",
        }}
      />

      {/* Content Container */}
      <div className="position-relative z-1 text-white">
        {/* Pending Fees */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="small text-white fs-4">Pending Fees:</span>
          <span className="fs-4 fw-bold">{feeDetails.pendingFees}/-</span>
        </div>

        {/* Progress Bar Section */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="small fs-4">Fees Paid:</span>
            <span className="text-white small fs-4">
              {feeDetails.feesPaid}/-
            </span>
          </div>

          {/* Fees Paid Label */}
          <div className="d-flex justify-content-end">
            <span className="text-success fs-3 fw-semibold mb-3">
              {feeDetails.pendingFees === 0 ? "Fees Paid!" : "Pending Payment!"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesProgress;
